export default class IndeterminateCheckboxes {
  constructor(node) {
    this.element = node;
    this.checkboxes = this.element.querySelectorAll("input[type='checkbox']");

    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", (e) => {
        const target = e.target;

        this.updateChildren(target);
        this.updateParents(target);

        this.element.dispatchEvent(new Event("indeterminate-changed"));
      });
    });
  }

  updateChildren(target) {
    const { checked } = target;

    this.getChildren(target).forEach((child) => {
      child.checked = checked;
      child.indeterminate = false;
    });
  }

  updateParents(target) {
    while ((target = this.getParent(target))) {
      let children = this.getChildren(target);
      let checked = [...children].filter((child) => child.checked).length;

      target.checked = checked === children.length;
      target.indeterminate = checked && !target.checked;
    }
  }

  getChildren(target) {
    target = target.closest("li");
    target = target && target.querySelector("ul");
    return (target && target.querySelectorAll('input[type="checkbox"]')) || [];
  }

  getParent(target) {
    target = target.closest("ul");
    target = target && target.closest("li");
    return target && target.querySelector('input[type="checkbox"]');
  }
}
